import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class FITH2SlideShowPage extends SlideShowPage {
    constructor(texture?: PIXI.Texture) {
        super(undefined, undefined, undefined, undefined);

        if (texture) {
            let featureImage: PIXI.Sprite = new PIXI.Sprite(texture);
            featureImage.anchor.set(0.5);
            this.addChild(featureImage);
        }
    }
}